import type { AxiosRequestConfig } from 'axios';

export const baseUrl = '';
export const API = '/api';
export const V1 = '/v1';
export const ADMIN = '/admin';
export const FORMS = '/forms';
export const V2 = '/v2';
export const baseRoutes = API + V1;
export const baseRoutesV2 = API + V2;
export const adminRoutes = baseRoutes + ADMIN;
export const formRoutes = baseRoutes + FORMS;

const config: AxiosRequestConfig = {
  baseURL: `${baseUrl}${adminRoutes}`,
  headers: {
    authorization: '',
  },
};

export { config };
